var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33329 2.33329C4.57187 2.33329 2.33329 4.57187 2.33329 7.33329C2.33329 10.0947 4.57187 12.3333 7.33329 12.3333C10.0947 12.3333 12.3333 10.0947 12.3333 7.33329C12.3333 4.57187 10.0947 2.33329 7.33329 2.33329ZM0.666626 7.33329C0.666626 3.65139 3.65139 0.666626 7.33329 0.666626C11.0152 0.666626 14 3.65139 14 7.33329C14 11.0152 11.0152 14 7.33329 14C3.65139 14 0.666626 11.0152 0.666626 7.33329Z",
    fill: "#576473"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9107 10.9107C11.2361 10.5853 11.7638 10.5853 12.0892 10.9107L17.0892 15.9107C17.4147 16.2361 17.4147 16.7638 17.0892 17.0892C16.7638 17.4147 16.2361 17.4147 15.9107 17.0892L10.9107 12.0892C10.5853 11.7638 10.5853 11.2361 10.9107 10.9107Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.7ec3c0b9e7cec56915890c5a18e4fc25.svg";
export { ForwardRef as ReactComponent };